import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IFilter } from '../../interfaces/ifilter';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IFilterDataResponse } from '../../interfaces/ifilter-event';
import { DatePipe } from '@angular/common';
import {FilterModel, IFilterData, IFilterModel } from '../../models/filter-model';
import { FilterService, IFilterSubject } from '../../services/filter.service';
import { filter } from 'rxjs';


export type IFilterText = [String?];


@Component({
  selector: 'split-filter-text',
  templateUrl: './split-filter-text.component.html',
  styleUrls: ['./split-filter-text.component.scss']
})
export class SplitFilterTextComponent implements OnChanges, OnInit {
  value: string = '';

  @Input() data: IFilterData[] = [];

  @Input() field!: string;

  @Input() label!: string;

  @Input() key!: string;
  @Input() groupId!: string;

  protected _data: IFilterText = [];

  protected filterModel!: IFilterModel;


  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  @ViewChild('op') public overlayPanel!: OverlayPanel;
  isActiveOverlay: boolean = false;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.filters = this.filterModel;

    this.filterService.filterSubject.pipe(
      filter((data: IFilterSubject) => data.action === "CLEAR"),
      filter((event: IFilterSubject) => event.id === this.groupId)
    ).subscribe(
      (data: IFilterSubject) => {
        this._data = [];
        this.value = '';
        this.onEmit();
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
   if(changes["data"]) {
     this._data = this.copy();
   }  

   if(changes["key"]) {
    this.filterModel = {
      id: this.groupId,
      type: "SEARCH",
      key: this.key,
      data: [],
      filter: []
    }
   }
  }

  copy() {
    console.log(this.data);
    return this.data.map((item) => item.name) as IFilterText;
  }

  showOverlayPanel(event: any) {
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  hideOverlayPanel() {
    this._data = this.copy();
    this.isActiveOverlay = false;
  }

  onCancel() {
    this._data = [];
    this.onEmit();
    this.overlayPanel.hide();
  }

  onEmit() { 
    let filter: IFilter[] = [];
    let data: IFilterData[] = [];
    if(this.value != '') {
      data = [{id: this.value, name: this.key}] as IFilterData[];
    
      filter = [
        {
          key: this.key,
          property: this.field,
          value: this.value
        }
      ];
    }

    let filterModel: IFilterModel  = {
      ...this.filterModel,
      data: data,
      filter: filter
    };
    this.data = filterModel.data;
    this.filterService.send(filterModel);
    this.onFilterEvent.emit(filterModel);
    this.overlayPanel.hide();
  }

  setValue(value: string) {
    this.value = value;
  }
}
